import { render, staticRenderFns } from "./radishScoreInner.vue?vue&type=template&id=220c25b7&scoped=true"
import script from "./radishScoreInner.vue?vue&type=script&lang=js"
export * from "./radishScoreInner.vue?vue&type=script&lang=js"
import style0 from "./radishScoreInner.vue?vue&type=style&index=0&id=220c25b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c25b7",
  null
  
)

export default component.exports